import React from "react";
import { FiX } from "react-icons/fi"; // Cross icon for closing
import "../Category/CardSlider.css";

const CardSlider = ({ cart, onClose, updateCart, removeFromCart, isOpen }) => {
  if (cart.length === 0) return null; // Don't show slider if cart is empty

  return (
    <div className={`card-slider ${isOpen ? "open" : ""}`}>
      <div className="slider-header">
        <h3>Complete Your Purchase</h3>
        <button className="close-slider" onClick={onClose}>
          <FiX />
        </button>
      </div>

      <div className="cart-items">
        {cart.map((product) => (
          <div className="cart-item" key={product.id}>
            <div className="cart-item-image">
              {/* Image path updated */}
              <img src={`${product.image}`} alt={product.name} />
            </div>
            <div className="cart-item-details">
              <h4>{product.name}</h4>
              <p>{product.description}</p>
              <p>
                Total: ₹{(product.price * product.quantity).toFixed(2)} (Quantity: {product.quantity})
              </p>
             
              <button className="remove-item" onClick={() => removeFromCart(product.id)}>
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>

      <button className="checkout-btn">Proceed to Checkout</button>
    </div>
  );
};

export default CardSlider;
